import { useQuery } from "react-query";
import { fetchUsers } from "../../api/fetchUsers";
import UserCacheName from "../../utils/UserCacheName";

export const useFetchUsers = () => {
  return useQuery({
    queryKey: [UserCacheName.getUserList()],
    queryFn: fetchUsers,
  });
};
